import script from "./AdminCauldronRail.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCauldronRail.vue?vue&type=script&setup=true&lang=js"

import "./AdminCauldronRail.vue?vue&type=style&index=0&id=39d387dd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39d387dd"]])

export default __exports__